import {classNames} from "primereact/utils";
import {ProgressBar} from "primereact/progressbar";
import React, {useEffect, useState} from "react";
import {useAppSelector} from "../../../../redux/hooks";
import {Divider} from "primereact/divider";
import {DataTable} from "primereact/datatable";
import {Column} from "primereact/column";
import {Badge} from "primereact/badge";

const StatusesByPeriodDetails = (props: any) => {
    const detailsLoading = useAppSelector(state => state.StatusesByPeriodListReducer.loading);
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);

    const statusByPeriodData = props.selectedRowData;

    useEffect(() => {
        const handleResize = () => {
            setWindowWidth(window.innerWidth);
        };
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    const formatDateTime = (dateString: any) => {
        if (!dateString) return '-';
        const date = new Date(dateString);
        return `${date.toLocaleTimeString([], {hour: '2-digit', minute: '2-digit', second: '2-digit'})} ${date.toLocaleDateString('en-GB')}`;
    };

    const formatDuration = (seconds: any) => {
        if (!seconds) return '00:00:00';
        const hours = Math.floor(seconds / 3600);
        const minutes = Math.floor((seconds % 3600) / 60);
        const remainingSeconds = seconds % 60;
        return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${remainingSeconds.toString().padStart(2, '0')}`;
    };

    const getStatusColor = (color: any) => {
        return color || '#6c757d';
    };

    const mapFields = [
        {
            label: '',
            value: <Badge value={statusByPeriodData?.statusName} className={`p-badge text-white customer-badge text-xs p-0 mr-4 my-2`} style={{borderRadius: '6px', backgroundColor: `${getStatusColor(statusByPeriodData.statusColor)}`, minWidth: '180px'}}/>
        },
        {
            label: 'Ініціатор зміни',
            value: statusByPeriodData?.changeType || '-'
        },
        {
            label: 'Час в статусі',
            value: formatDuration(statusByPeriodData?.timeInStatus)
        },
        {
            label: 'Час початку',
            value: formatDateTime(statusByPeriodData?.timeStart)
        },
        {
            label: 'Час завершення',
            value: formatDateTime(statusByPeriodData?.timeEnd)
        }
    ];

    return (
        <div className="relative">
            {detailsLoading && <ProgressBar mode="indeterminate" style={{height: '6px'}}></ProgressBar>}
            <div className={classNames('grid', {'opacity-50': detailsLoading})}
                 style={{paddingTop: "0.3rem", padding: '0.3rem 10px 5px'}}>
                {windowWidth > 1248 && (
                    <div className="grid col-12 md:col-12 mb-0 px-0 w-full justify-content-between">
                        <div className="absolute top-0 right-0 pr-2">
                            <button className="close-button block cursor-pointer ml-auto"
                                    onClick={() => {
                                        props.setSelectedRowData(null);
                                        props.setSelectedRowExpansion(null);
                                    }
                                    }><span className="pi pi-times"></span>
                            </button>
                        </div>
                        <div className="field col-12 md:col-10 flex align-items-start m-0 pb-3 pl-0">
                            <div className="field col-12 md:col-12 flex m-0 py-0 flex-column">
                                <div className="flex align-items-center pl-2 mb-2">
                                    <div className="mr-2 font-semibold">{statusByPeriodData?.userName || 'Невідомий користувач'}</div>
                                    {statusByPeriodData?.statusColor && (
                                        <div
                                            className="status-color-indicator"
                                            style={{
                                                width: '12px',
                                                height: '12px',
                                                backgroundColor: getStatusColor(statusByPeriodData.statusColor),
                                                borderRadius: '50%',
                                                marginLeft: '8px'
                                            }}
                                        />
                                    )}
                                </div>
                            </div>
                        </div>
                        <Divider className="mt-0 ml-2 mb-1"/>
                        <div className="grid col-12 md:col-12">
                                <DataTable className="col-12 md:col-12 py-0" value={[mapFields]}
                                >
                                    <Column
                                        header={'Статус'}
                                        className="justify-content-start"
                                        body={() =><Badge value={statusByPeriodData?.statusName} className={`p-badge text-white customer-badge text-xs p-0 mr-4 my-2 px-2`} style={{borderRadius: '6px', backgroundColor: `${getStatusColor(statusByPeriodData.statusColor)}`, minWidth: '180px'}}/>}
                                        style={{cursor: 'pointer', width: '20%'}}

                                    />
                                    <Column
                                        header={'Час в статусі'}
                                        className="justify-content-start"
                                        body={() => formatDuration(statusByPeriodData?.timeInStatus) || '00:00:00'}
                                        style={{cursor: 'pointer', width: '20%'}}
                                    />
                                    <Column
                                        header={'Ініціатор зміни'}
                                        className="justify-content-start"
                                        body={() => statusByPeriodData?.changeType ||  '- - -'}
                                        style={{cursor: 'pointer', width: '20%'}}

                                    />
                                    <Column
                                        header={'Початок'}
                                        className="justify-content-start"
                                        body={() => formatDateTime(statusByPeriodData?.timeStart) ||  '- - -'}
                                        style={{cursor: 'pointer', width: '20%'}}

                                    />
                                    <Column
                                        header={'Завершення'}
                                        className="justify-content-start"
                                        body={() => formatDateTime(statusByPeriodData?.timeEnd) ||  '- - -'}
                                        style={{cursor: 'pointer', width: '20%'}}

                                    />
                                </DataTable>
                        </div>
                    </div>
                )}
                {windowWidth <= 1248 && (
                    <React.Fragment>
                        {mapFields?.map((field: any, index: number) => (
                            <React.Fragment key={index}>
                                <div className="field col-12 md:col-12 align-items-center m-0 py-1">
                                    <p className="text-sm font-medium m-0">{field.label || ''}</p>
                                </div>
                                <div className="field col-12 md:col-12 align-items-center m-0 py-1">
                                    <p className="text-sm m-0">{field.value}</p>
                                </div>
                                <Divider/>
                            </React.Fragment>
                        ))}
                    </React.Fragment>
                )}
            </div>
        </div>
    );
};

export default StatusesByPeriodDetails;
